const siteMap = [
  {
    name: "home",
    href: "/",
  },
  {
    name: "creative projects",
    href: "/blog",
  },
];

export default siteMap;
